// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"z3-z","refreshPageWarning":"A3-z","redirectMessageText":"B3-z"};